



















































import Vue, { VueConstructor } from 'vue';
import { uiSettingsService, userService, authService, loadingService, loggerService } from '@/services';
import { UserMixin } from '@/mixins/UserMixin';

export default (Vue as VueConstructor<Vue & InstanceType<typeof UserMixin>>).extend({
  name: 'Account',

  mixins: [UserMixin],

  data: () => ({
    tab: null,
    showDeleteDialog: false
  }),

  methods: {
    cancelDeleteAccount(): void {
      this.showDeleteDialog = false;
    },

    async deleteAccount(): Promise<void> {
      try {
        this.showDeleteDialog = false;
        loadingService.startLoading();

        await userService.deleteUser(this.userId);
        authService.logout();
      } catch (error) {
        loggerService.error(error);
      } finally {
        loadingService.stopLoading();
      }
    }
  },

  computed: {
    isDarkThemeSet: {
      get(): boolean {
        return uiSettingsService.darkThemeSet;
      },

      set(value: boolean): void {
        this.$vuetify.theme.dark = value;
        uiSettingsService.darkThemeSet = value;
      }
    }
  }
});
